import request from "@/utils/request";
import { apiConfig } from "../config/api";

// 项目分页
export function getProjectPager(req, pager) {
  return request({
    url: apiConfig.projectInfo.api.pager.url,
    method: "post",
    data: {
      projectName: req.projectName,
      status: req.status,
      agentIds: req.agentIds,
      startDate: req.startDate,
      endDate: req.endDate,
      page: pager.page,
      pageSize: pager.pageSize
    }
  });
}

// 项目分页搜索功能
export function searchProjectPager(req, pager) {
  return request({
    url: apiConfig.projectInfo.api.searchPager.url,
    method: "post",
    data: {
      projectName: req.projectName,
      status: req.status,
      agentIds: req.agentIds,
      startDate: req.startDate,
      endDate: req.endDate,
      page: pager.page,
      pageSize: pager.pageSize
    }
  });
}
// 项目列表
export function projectList(req) {
  return request({
    url: apiConfig.projectInfo.api.projectList.url,
    method: "get",
    params: req
  });
}
// 编辑项目
export function editProject(req) {
  return request({
    url: apiConfig.projectInfo.api.edit.url,
    method: "post",
    data: {
      bscProject: {
        id: req.id,
        projectName: req.projectName,
        projectType: req.projectType,
        projectLevel: req.projectLevel,
        projectMajor: req.projectMajor,
        scales: req.scales,
        certificateName: req.certificateName,
        startDate: req.startDate,
        endDate: req.endDate
      },
      agentId: req.agentIds
    }
  });
}
// 查看项目机构分页
export function getProjectAgentPager(req) {
  return request({
    url: apiConfig.projectInfo.api.findProjectAgentPager.url,
    method: "post",
    data: {
      projectId: req.projectId,
      page: req.page,
      pageSize: req.pageSize
    }
  });
}

// 获取机构列表
export function agentList(req) {
  return request({
    url: apiConfig.projectInfo.api.authorizeAgent.url.agentList,
    method: "post",
    data: {
      realName: req.realName,
      idNumber: req.idNumber,
      registerFrom: req.registerFrom,
      baseInfoAuditStatus: req.baseInfoAuditStatus,
      startDate: req.startDate,
      endDate: req.endDate
    }
  });
}
// 授权机构
export function authorizeAgent(req) {
  return request({
    url: apiConfig.projectInfo.api.authorizeAgent.url.authorize,
    method: "post",
    data: {
      agentId: req.agentId,
      bscProject: {
        id: req.projectId
      }
    }
  });
}
// 暂停项目
export function suspendProject(req) {
  return request({
    url: apiConfig.projectInfo.api.suspend.url,
    method: "post",
    data: {
      id: req.projectId,
      status: 3
    }
  });
}
// 开放项目
export function openProject(req) {
  return request({
    url: apiConfig.projectInfo.api.open.url,
    method: "post",
    data: {
      id: req.projectId,
      status: 2
    }
  });
}
// 删除项目
export function deleteProject(req) {
  return request({
    url: apiConfig.projectInfo.api.delete.url,
    method: "post",
    data: {
      id: req.projectId,
      isDel: 0
    }
  });
}
// 查询项目用户
export function getProjectUser(projectId) {
  return request({
    url: apiConfig.projectInfo.api.getProjectUser.url,
    method: "get",
    params: {
      projectId: projectId
    }
  });
}
// 项目统计
export function profile(req) {
  return request({
    url: apiConfig.projectStatistics.api.profile.url,
    method: "post",
    data: {
      agentIds: req
    }
  });
}
// 查看项目详情分页
export function detailPager(projectId, agentIds, page) {
  return request({
    url: apiConfig.projectStatistics.api.detail.url.pager,
    method: "post",
    data: {
      projectId: projectId,
      agentIds: agentIds,
      page: page.page,
      pageSize: page.pageSize
    }
  });
}
// 查询参与项目用户列表
export function getProjectUserPager(req) {
  return request({
    url: apiConfig.projectStatistics.api.detail.url.projectUserPager,
    method: "post",
    data: {
      projectId: req.projectId,
      agentName: req.agentName,
      page: req.page,
      pageSize: req.pageSize
    }
  });
}

//查询所有项目id
export function getProjecsId(req) {
  return request({
    url: apiConfig.projectInfo.api.getProjectsId.url,
    method: "get",
    params: req
  });
}

//根据机构id查询项目
export function searchProjectByAgentIds(req) {
  return request({
    url: apiConfig.projectInfo.api.searchProjectByAgentIds.url,
    method: "post",
    data: {
      agentIds: req
    }
  });
}

//导出项目统计收益
export function downloadProjectDetail(req) {
  return request({
    url: apiConfig.projectStatistics.api.detail.url.downloadProjectDetail,
    method: "post",
    data: {
      agentIds: req
    },
    responseType: "blob"
  });
}
